import type { MetricsDistributionResponse } from "../../../../../shared/api/types";

export interface ProgressBarData {
  label: string;
  value: number;
}

export const transformProgrammeGoals = (
  data: MetricsDistributionResponse | undefined
): ProgressBarData[] => {
  if (!data?.data?.distribution || data.data.distribution.length === 0)
    return [];

  const parseGoals = (rawValue: string) => {
    let raw = rawValue.trim();
    if (!raw) return [];
    if (raw.startsWith("{") && raw.endsWith("}")) {
      raw = raw.slice(1, -1);
    }
    const parts = raw.includes(",") ? raw.split(",") : [raw];
    return parts
      .map((part) => part.trim().replace(/^"+|"+$/g, ""))
      .filter(Boolean);
  };

  return data.data.distribution
    .map((item) => {
      const goals = parseGoals(item.name || "");
      return goals.map((goal) => ({
        label: goal
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        value: item.value,
      }));
    })
    .flat()
    .reduce((acc, item) => {
      const existing = acc.find((i) => i.label === item.label);
      if (existing) {
        existing.value += item.value;
      } else {
        acc.push({ ...item });
      }
      return acc;
    }, [] as ProgressBarData[])
    .sort((a, b) => b.value - a.value);
};
